import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'

class MapFullscreen extends PureComponent {
    render() {
        const { onClick, icon } = this.props

        const fullScreen = {
            height: '32px',
            width: '32px',
            borderRadius: '6.4px',
            backgroundColor: '#FFFFFF',
            boxShadow: '0 2px 3px 0 rgba(0,0,0,0.2)',
            position: 'absolute',
            right: '15px',
            top: '10px',
            zIndex: '1000',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }

        return (
            <Button id="mapFull" onClick={onClick} style={fullScreen}>
                <img src={icon} style={{ outline: 'none' }} />
            </Button>
        )
    }
}

export default MapFullscreen
